/** @jsx jsx */

import { Spacing } from '@zapier/theme';
import { jsx, css } from '@emotion/core';

import CtaCreateZap from 'app/developer-v3/components/CtaCreateZap';
import { LayoutStyles } from 'app/developer-v3/layouts/constants';

const Styles = {
  root: css`
    margin: ${LayoutStyles.verticalPadding} ${LayoutStyles.horizontalPadding}
      ${Spacing.none};
  `,
};

type Props = {
  isSetup: boolean;
};

export default function CTA({ isSetup }: Props) {
  return (
    isSetup && (
      <div css={Styles.root}>
        <CtaCreateZap type="action" />
      </div>
    )
  );
}
